import React, { useContext } from "react";
import { TransparentButton } from "components/forms/fields";
import { getConfig } from "config";
import __ from "utils/i18n";
import { PermissionsContext } from "contexts/permissionsContext";
import { useSelector } from "react-redux";
import { Row, Col } from 'reactstrap';
import AccountDetailsFull from "./AccountDetailsFull";
import AccountDetailsDefault from "./AccountDetailsDefault";
import { tenantName } from 'config/envConfig';

const AccountDetails = (props) => {

  const { data, toggleForm } = props;

  const { userPermissions } = useContext(PermissionsContext);
  const user = useSelector((state) => state.login.user);
  
  const isEditBankAccountEnabled = userPermissions?.includes('bank_account_modal_action_edit');
  const canChangeCbu = tenantName === 'openpay-ar' ? user?.canChangeCbu : true;
  const colSize = getConfig('customConfig.bankAccountModal.detailColSize', 3);

  const isBankAccountSelectFormActive = getConfig('customConfig.showBankAccountSelectForm');
  
  return (
    <div className="bank-account-modal-details">
      <Row className={"bank-account-detail-wrapper"}>
        <Col lg="9" md="12" className={'bank-account-row-detail'}>
          { isBankAccountSelectFormActive ? <AccountDetailsFull data={data} /> : <AccountDetailsDefault data={data}/> }
        </Col>
        <Col lg={colSize} md="12">
          {isEditBankAccountEnabled && canChangeCbu && (
            <div className="bank-account-modal-button">
              <TransparentButton onClick={toggleForm}>
                {__("dashboard.components.modal.changeBankAccount")}
              </TransparentButton>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AccountDetails;
